module.exports = {
	"nl": {
		"hqm": {
			"support-button": "Krijg support",
			"support-page": {
				"create-ticket": {
					"title": "Krijg support",
					"instructions": "Dien hieronder een verzoek in en wij nemen contact met je op.",
					"fields": {
						"mid": {
							"label": "Kies webwinkel",
							"validation": "Winkel is vereist"
						},
						"topic": {
							"question": "Waar gaat je vraag over?",
							"label": "Selecteer een onderwerp",
							"validation": "Onderwerp is vereist",
							"options": {
								"orders": "Bestellingen",
								"settlements": "Afrekeningen",
								"agreements": "Overeenkomsten",
								"technical_issues": "Technische problemen",
								"others": "Overige"
							}
						},
						"subject": {
							"label": "Onderwerp",
							"validation": "Onderwerp is vereist"
						},
						"description": {
							"label": "Bericht",
							"validation": "Omschrijving is vereist"
						},
						"attachment": {
							"label": "Bijlagen toevoegen",
							"button": "Upload",
							"info": "Door screenshots toe te voegen help je ons het probleem sneller op te lossen.",
							"supportedFileTypes": "Ondersteunde bestandstypen: .png, .jpg, .pdf",
							"error": "De totale bestandsgrootte mag niet meer zijn dan 15 MB"
						}
					},
					"submit": "Verzoek indienen",
					"service-unavailable-error": "Oeps. Er is iets misgegaan, probeer het over een paar minuten nog eens. Als het probleem zich blijft voordoen, vraag {link} om hulp.",
					"contact-page-link": "neem contact met ons op"
				},
				"view-ticket": {
					"title": "Klaar!",
					"details": "We hebben je verzoek ontvangen en je krijgt zo snel mogelijk een antwoord. Dit zijn je gegevens:",
					"ticket": "Verzoek #{ticketId}",
					"email": "E-mailadres: {email}",
					"status": "Je kunt de status bekijken op onze Support-pagina.",
					"track": "Status bekijken"
				}
			},
			"popup": {
				"yes": "Ja",
				"no": "Nee",
				"somethingElse": "Ik heb ergens anders hulp bij nodig"
			},
			"header": {
				"homeLink": "Reset"
			},
			"home": {
				"greeting": "Hallo {givenName}! Hoe kunnen we je helpen?",
				"topics": "Waar heb je hulp bij nodig?"
			},
			"topics": {
				"expandButton": "Meer"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Jammer dat dit niet heeft geholpen. Misschien kunnen sommige van deze artikelen je helpen?",
				"stillQuestionsTitle": "Heb je nog steeds vragen?",
				"stillQuestionsParagraph": "Je kunt ook rechtstreeks contact met ons opnemen.",
				"contactButton": "Neem contact met ons op"
			},
			"feedback": {
				"title": "Heeft dit geholpen?",
				"optionYes": "Ja, dit heeft geholpen",
				"optionNo": "Nee, ik heb meer hulp nodig",
				"positiveFeedback": "Bedankt voor de positieve feedback, dit helpt ons om je in de toekomst meer relevante artikelen te kunnen bieden."
			},
			"freeTextFeedback": {
				"title": "Help ons te verbeteren",
				"placeholder": "Waarom vond je deze informatie niet nuttig?",
				"submitButton": "Verzenden",
				"feedbackMessage": "Bedankt voor je feedback, dit helpt ons om je in de toekomst meer relevante artikelen te kunnen bieden."
			},
			"relatedContent": {
				"title": "Gerelateerde informatie"
			},
			"search": {
				"buttonLabel": "Zoeken",
				"input": "Zoek naar artikelen...",
				"loading": "Laden...",
				"results": {
					"contact": "Kun je de hulp niet vinden die je nodig hebt?",
					"empty": "Sorry, er zijn geen resultaten gevonden voor je vraag. Probeer via een andere term te zoeken.",
					"singleTopicFound": "We vonden 1 onderwerp",
					"multipleTopicsFound": "We vonden {count} onderwerpen",
					"singleArticleFound": "We vonden 1 artikel",
					"multipleArticlesFound": "We vonden {count} artikelen"
				}
			},
			"contact": {
				"title": "Neem contact met ons op",
				"channelsIntro": "Neem contact met ons op zodat we je kunnen helpen.",
				"businessDetailsTitle": "Je bedrijfsgegevens",
				"businessDetailsName": "Bedrijfsnaam",
				"businessDetailsEmail": "E-mailadres",
				"businessDetailsMid": "Webwinkel-ID",
				"phone": {
					"title": "Bel ons",
					"paragraph": "Je kunt ons op werkdagen tijdens kantooruren bellen. Als je in Zweden of het Verenigd Koninkrijk bent gevestigd, kun je ons ook in het weekend tussen 10.00 en 16.00 uur bellen."
				},
				"chat": {
					"title": "Chat met ons",
					"paragraph": "De snelste en simpelste manier om Support te bereiken. Onze chat is momenteel geopend.",
					"button": "Open Chat"
				},
				"email": {
					"title": "E-mail ons",
					"paragraph": "Stuur ons een e-mail en we nemen zo snel mogelijk contact met je op."
				}
			},
			"errorBoundary": {
				"title": "Er is een fout opgetreden",
				"message": "Het spijt ons, maar er is een fout opgetreden. Je kunt op de knop hieronder klikken om deze zijbalk te resetten en te sluiten.",
				"resetButton": "Reset",
				"errorId": "Fout-ID: {errorId}"
			},
			"tour": {
				"prev": "Vorige",
				"next": "Volgende",
				"done": "Klaar"
			},
			"notAvailableMobile": {
				"title": "Niet beschikbaar",
				"buttonBack": "Terug",
				"paragraph": "Deze inhoud is niet beschikbaar op je apparaat. Probeer het te openen op een apparaat met een groter scherm, zoals een desktopcomputer."
			},
			"shareButton": {
				"title": {
					"article": "Deel een deeplink naar dit artikel",
					"topic": "Deel een deeplink naar dit onderwerp",
					"tour": "Deel een deeplink naar deze rondleiding"
				},
				"radioItemHome": "Home App",
				"descriptionHome": "Opent hulpartikel op de homepage van de Merchant Portal ",
				"radioItemCurrent": "Huidige pagina",
				"descriptionCurrent": "Opent hulpartikel op de huidige pagina"
			}
		},
		"orientation": {
			"title": "Ontdek meer over ..."
		},
		"core": {
			"alert": {
				"message": "Er is een fout opgetreden! Probeer het opnieuw.",
				"correlationIdLabel": "Correlation ID:"
			},
			"header": {
				"title": "Merchant Portal"
			},
			"usermenu": {
				"language": "Taal",
				"country": "Land",
				"timezone": "Tijdzone",
				"logout": "Uitloggen",
				"profile": "Profiel",
				"changeProfile": "Bewerken",
				"tooltip": "Jouw profiel"
			},
			"appsmenu": {
				"defaultTooltip": "Jouw apps",
				"initialTooltip": "Vind je apps hier",
				"newAppsTooltip": "We hebben nieuwe apps voor je!"
			},
			"helpful-question-mark": {
				"helpLabel": "Help"
			},
			"languages": {
				"da": "Deens",
				"de": "Duits",
				"en": "Engels",
				"en_GB": "Engels (GB)",
				"en_US": "Engels (VS)",
				"es": "Spaans",
				"fi": "Fins",
				"fr": "Frans",
				"it": "Italiaans",
				"nl": "Nederlands",
				"no": "Noors",
				"sv": "Zweeds"
			},
			"countries": {
				"de": "Duitsland",
				"dk": "Denemarken",
				"fi": "Finland",
				"gb": "Verenigd Koninkrijk",
				"nl": "Nederland",
				"no": "Noorwegen",
				"se": "Zweden",
				"us": "Verenigde Staten"
			},
			"selectLanguage": {
				"title": "Selecteer je taal",
				"paragraph": "Dit wordt de standaardtaal",
				"submit": "Oké"
			},
			"selectCountry": {
				"title": "Selecteer je land",
				"paragraph": "Dit wordt je standaardland.",
				"submit": "Oké"
			},
			"updateProfile": {
				"title": "Update Gegevens",
				"submit": "Oké",
				"emailLabel": "E-mailadres",
				"firstNameLabel": "Voornaam",
				"lastNameLabel": "Achternaam",
				"resetPasswordLabel": "Reset wachtwoord",
				"resetPasswordSuccessLabel": "E-mail om het wachtwoord te resetten verstuurd",
				"resetPasswordErrorLabel": "Verzenden van e-mail om het wachtwoord te resetten mislukt",
				"error": "Gegevensupdate mislukt"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle rechten voorbehouden",
					"oc": "Copyright © 2005-{currentYear} Klarna Australië Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Derde Etage, Columbus, OH 43215"
				},
				"terms": "Algemene voorwaarden"
			},
			"accessDenied": {
				"title": "Voor deze pagina zijn aanvullende rechten nodig",
				"message": "Neem contact op met je Payment Service Provider of met Klarna"
			},
			"midSelector": {
				"label": "Webwinkel"
			},
			"storeSelector": {
				"label": "Webwinkel"
			},
			"storesSelector": {
				"closeText": "Klaar",
				"closeTextWithSelection": "# selectie(s) toepassen",
				"deselectAllOptionText": "Selectie wissen",
				"emptyStateText": "Geen winkels gevonden",
				"label": "Winkels",
				"searchFieldLabel": "Zoeken op winkel",
				"selectAllOptionText": "Selecteer alle winkels",
				"selectedAllText": "Alle winkels",
				"selectedText": "# winkels"
			},
			"pagination": {
				"ofLabel": "van",
				"noResultsLabel": "Geen resultaten"
			},
			"dateRangePicker": {
				"startLabel": "Begindatum",
				"endLabel": "Einddatum",
				"months": {
					"january": "Januari",
					"february": "Februari",
					"march": "Maart",
					"april": "April",
					"may": "Mei",
					"june": "Juni",
					"july": "Juli",
					"august": "Augustus",
					"september": "September",
					"october": "Oktober",
					"november": "November",
					"december": "December"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "D",
					"wednesday": "W",
					"thursday": "D",
					"friday": "V",
					"saturday": "Z",
					"sunday": "Z"
				}
			},
			"appIcon": {
				"newLabel": "NIEUW"
			},
			"appCategory": {
				"dayToDay": "Van dag-tot-dag",
				"nko": "Klarna Online",
				"tools": "Hulpmiddelen",
				"preferences": "Voorkeuren"
			},
			"apps": {
				"home-fe": {
					"title": "Start"
				},
				"nko-app": {
					"title": "Klarna Online Apps"
				},
				"orders-fe": {
					"title": "Bestellingen",
					"description": "Zoek en beheer je orders van Klarna.",
					"nkoLinkText": "Bekijk oudere orders"
				},
				"nko-orders": {
					"title": "Bestellingen (KO)",
					"description": "Zoek en beheer je orders geplaatst via Klarna Online."
				},
				"settlements-fe": {
					"title": "Afrekeningen",
					"description": "Bekijk je transacties en genereer rapporten voor afstemming.",
					"nkoLinkText": "Bekijk oudere verslagen"
				},
				"nko-settlements": {
					"title": "Afrekeningen (KO)",
					"description": "Vind verslagen van bestellingen en uitbetalingen van Klarna Online."
				},
				"logs-app-fe": {
					"title": "Logbestanden",
					"description": "API-logbestanden zoeken om integratieproblemen op te lossen."
				},
				"users-fe": {
					"title": "Gebruikers",
					"description": "Nodig nieuwe gebruikers uit en beheer bestaande gebruikers in het Portal."
				},
				"settings-fe": {
					"title": "Instellingen",
					"description": "Vraag je Klarna API-inloggegevens aan en beheer winkelinstellingen."
				},
				"nko-settings": {
					"title": "Instellingen (KO)",
					"description": "Beheer de instellingen voor je webwinkel, verslagen en contactgegevens."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Maak nieuwe bestellingen aan met de Klarna-oplossing voor in de winkel."
				},
				"products-fe": {
					"title": "Producten",
					"description": "Haal het maximale uit Klarna."
				},
				"upstream-fe": {
					"title": "Berichtgeving op Website",
					"description": "Verkoop meer dankzij het aangepaste en persoonlijke financieringsaanbod."
				},
				"lending-fe": {
					"title": "MKB-Lening",
					"description": "Bedrijfsfinanciering simpel gemaakt."
				},
				"branding-fe": {
					"title": "Branding",
					"description": "Behoud de controle over de presentatie van je merk binnen Klarna."
				},
				"disputes-fe": {
					"title": "Betwistingen",
					"description": "Behandel je betwistingen."
				},
				"logistics-fe": {
					"title": "Logistiek",
					"description": "Beheer al je logistiek op één plek."
				},
				"ob-transactions-fe": {
					"title": "Transacties",
					"description": "Openstaande Banktransacties"
				},
				"developers": {
					"title": "Ontwikkelaars"
				},
				"product-upgrade-fe": {
					"title": "Product-upgrade"
				},
				"marketing": {
					"title": "Marketing",
					"description": "Ga voor marketingmiddelen om je bedrijf te laten groeien."
				},
				"business-card-fe": {
					"title": "Visitekaartje",
					"description": "Binnenkort"
				},
				"support": {
					"title": "Support",
					"description": "Bekijk en beheer je supportverzoeken."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Terug"
				}
			},
			"errorBoundary": {
				"contact": "Probeer de pagina te herladen. {br}Als het probleem aanhoudt, neem dan contact op met <supportLink>Merchant Support</supportLink> en verstrek het ID {errorId}",
				"errorDescription": "Fout-ID - {errorId}",
				"reloadButton": "Herladen",
				"title": "Er is helaas een fout opgetreden"
			},
			"maintenance": {
				"pageTitle": "Onderhoud",
				"title": "Het Merchant Portal ondergaat momenteel gepland onderhoud.",
				"summary": "We zijn snel bij je terug",
				"scheduledSummary": "We zijn terug om {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "Een van de belangrijkste omzetdagen komt eraan. Tijdens Black Friday tonen wij u snel statistieken van uw verkopen. Laten we ons in de tussentijd voorbereiden op succes!",
				"countdown": "Begint over #dd #hu #mm #ss…",
				"box1": {
					"title": "3,5 x meer uitgaven*",
					"text": "Vorig jaar gaven Klarna-shoppers* gemiddeld 3,5 x meer uit op Black Friday dan op welke andere dag van het jaar dan ook.",
					"footnote": "*Gemiddeld over alle Klarna-webshopcategorieën en -regio's."
				},
				"box2": {
					"title": "2,5 x meer verkoopvolume*",
					"text": "Vorig jaar genereerden Klarna-webshops 2,5 x meer verkoopvolume op Black Friday dan op welke andere dag van het jaar dan ook.",
					"footnote": "*Gemiddeld over alle Klarna-webshopcategorieën en -regio's."
				},
				"sectionTitle": "Laat uw Black Friday verkopen stijgen",
				"marketing": {
					"title": "Promoot uw bedrijf voor en op Black Friday",
					"text": "Verwijs meer shoppers naar uw winkel tijdens het Black Friday winkelseizoen met deze gratis te gebruiken hulpmiddelen voor sociale media en e-mailcampagnes."
				},
				"branding": {
					"title": "Val op in de Klarna app",
					"text": "Elke maand gebruiken 12 miljoen shoppers de Klarna app. Zorg ervoor dat u deze Black Friday opvalt in de app door hier in het Handelaarsportaal uw merkinformatie toe te voegen en bij te werken."
				},
				"cta": "Begin nu",
				"close": "Afsluiten"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Bestelvolume",
				"orderCountTitle": "Aangemaakte bestellingen",
				"orderCount": "{count} bestellingen",
				"box": {
					"title": "Wil je je conversie verder verhogen?",
					"subtitle1": "On-site messaging",
					"subtitle2": "Reclameberichten die informeren.",
					"text": "Onze On-site messaging-tool helpt je verkopen en gemiddelde bestelwaarde te verhogen met reclameberichten. Laat je klanten weten wat hun betaalmogelijkheden zijn zodra ze je site bezoeken, tot aan het afrekenen.",
					"cta": "Begin nu"
				},
				"selector": {
					"done": "Klaar",
					"applySelection": "# selectie(s) toepassen",
					"selectAll": "Selecteer alle",
					"allOptions": "Alle opties geselecteerd",
					"someOptions": "# opties geselecteerd",
					"storeMultiSelectLabel": "Kies # winkels",
					"allStores": "Alle winkels"
				},
				"currencyLabel": "Kies valuta",
				"storeLabel": "Kies winkel"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Dit zijn uw verkopen tijdens een van de belangrijkste verkoopweken van het jaar.",
				"summaryTitle": "Samenvatting",
				"orderVolume": "Totaal volume",
				"orderCount": "Totaal bestellingen",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "vergeleken met dezelfde dag vorige week",
				"tabs": {
					"monday": "Maandag",
					"tuesday": "Dinsdag",
					"wednesday": "Woensdag",
					"thursday": "Donderdag",
					"blackFriday": "Black Friday",
					"saturday": "Zaterdag",
					"sunday": "Zondag",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};